<template>
  <nav-section />
  <router-view></router-view>
  <FooterSection />
</template>

<script>
import NavSection from "./components/NavSection.vue";
import FooterSection from "./components/FooterSection.vue";

export default {
  name: "App",
  components: {
    NavSection,
    FooterSection,
  },
};
</script>

<style>
#app {
  font-family: "Ubuntu", sans-serif;
  text-align: center;
  background-image: url("C:\Users\josue\OneDrive\Desktop\Repos\personal-site\images\abstract-2.jpg");
  background-size: cover;
  background-attachment: fixed;
}

body {
  margin: 0;
  padding: 0;
}

@media screen and (max-width: 768px) {
  body {
    overflow: scroll;
  }
}
</style>
